/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/cs.js'



import {Notify,Dialog,Meta} from 'quasar'



export default { config: {"brand":{"primary":"#ED4374","secondary":"#1097DB","dark-page":"#121212","positive":"#15ce81","negative":"#eb3f3f","info":"#31ccec","warning":"#f2c037","chart-secondary":"#E68EFC"}},lang,plugins: {Notify,Dialog,Meta} }

